/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CallFinishedWebhookPayload } from '../models/call-finished-webhook-payload';
import { CallStartedWebhookPayload } from '../models/call-started-webhook-payload';
import { ConversationCompleteWebhookPayload } from '../models/conversation-complete-webhook-payload';
import { ConversationStartedWebhookPayload } from '../models/conversation-started-webhook-payload';
import { postCallFinishedWebhookSchema } from '../fn/webhook-events/post-call-finished-webhook-schema';
import { PostCallFinishedWebhookSchema$Params } from '../fn/webhook-events/post-call-finished-webhook-schema';
import { postCallStartedWebhookSchema } from '../fn/webhook-events/post-call-started-webhook-schema';
import { PostCallStartedWebhookSchema$Params } from '../fn/webhook-events/post-call-started-webhook-schema';
import { postConversationCompleteWebhookSchema } from '../fn/webhook-events/post-conversation-complete-webhook-schema';
import { PostConversationCompleteWebhookSchema$Params } from '../fn/webhook-events/post-conversation-complete-webhook-schema';
import { postConversationStartedWebhookSchema } from '../fn/webhook-events/post-conversation-started-webhook-schema';
import { PostConversationStartedWebhookSchema$Params } from '../fn/webhook-events/post-conversation-started-webhook-schema';

@Injectable({ providedIn: 'root' })
export class WebhookEventsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postConversationCompleteWebhookSchema()` */
  static readonly PostConversationCompleteWebhookSchemaPath = '/api/webhooks/notifications/events/ConversationComplete';

  /**
   * ConversationComplete webhook payload schema (documentation only).
   *
   * ⚠️ DO NOT CALL THIS ENDPOINT - it's for documentation only! This shows the structure of 'ConversationComplete' webhook payload that will be sent to your webhook URL.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConversationCompleteWebhookSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  postConversationCompleteWebhookSchema$Response(params?: PostConversationCompleteWebhookSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<ConversationCompleteWebhookPayload>> {
    const obs = postConversationCompleteWebhookSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * ConversationComplete webhook payload schema (documentation only).
   *
   * ⚠️ DO NOT CALL THIS ENDPOINT - it's for documentation only! This shows the structure of 'ConversationComplete' webhook payload that will be sent to your webhook URL.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postConversationCompleteWebhookSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postConversationCompleteWebhookSchema(params?: PostConversationCompleteWebhookSchema$Params, context?: HttpContext): Observable<ConversationCompleteWebhookPayload> {
    const resp = this.postConversationCompleteWebhookSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConversationCompleteWebhookPayload>): ConversationCompleteWebhookPayload => r.body)
    );
  }

  /** Path part for operation `postConversationStartedWebhookSchema()` */
  static readonly PostConversationStartedWebhookSchemaPath = '/api/webhooks/notifications/events/ConversationStarted';

  /**
   * ConversationStarted webhook payload schema (documentation only).
   *
   * ⚠️ DO NOT CALL THIS ENDPOINT - it's for documentation only! This shows the structure of 'ConversationStarted' webhook payload that will be sent to your webhook URL.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConversationStartedWebhookSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  postConversationStartedWebhookSchema$Response(params?: PostConversationStartedWebhookSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<ConversationStartedWebhookPayload>> {
    const obs = postConversationStartedWebhookSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * ConversationStarted webhook payload schema (documentation only).
   *
   * ⚠️ DO NOT CALL THIS ENDPOINT - it's for documentation only! This shows the structure of 'ConversationStarted' webhook payload that will be sent to your webhook URL.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postConversationStartedWebhookSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postConversationStartedWebhookSchema(params?: PostConversationStartedWebhookSchema$Params, context?: HttpContext): Observable<ConversationStartedWebhookPayload> {
    const resp = this.postConversationStartedWebhookSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConversationStartedWebhookPayload>): ConversationStartedWebhookPayload => r.body)
    );
  }

  /** Path part for operation `postCallStartedWebhookSchema()` */
  static readonly PostCallStartedWebhookSchemaPath = '/api/webhooks/notifications/events/CallStarted';

  /**
   * CallStarted webhook payload schema (documentation only).
   *
   * ⚠️ DO NOT CALL THIS ENDPOINT - it's for documentation only! This shows the structure of 'CallStarted' webhook payload that will be sent to your webhook URL.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postCallStartedWebhookSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  postCallStartedWebhookSchema$Response(params?: PostCallStartedWebhookSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CallStartedWebhookPayload>> {
    const obs = postCallStartedWebhookSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * CallStarted webhook payload schema (documentation only).
   *
   * ⚠️ DO NOT CALL THIS ENDPOINT - it's for documentation only! This shows the structure of 'CallStarted' webhook payload that will be sent to your webhook URL.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postCallStartedWebhookSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postCallStartedWebhookSchema(params?: PostCallStartedWebhookSchema$Params, context?: HttpContext): Observable<CallStartedWebhookPayload> {
    const resp = this.postCallStartedWebhookSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CallStartedWebhookPayload>): CallStartedWebhookPayload => r.body)
    );
  }

  /** Path part for operation `postCallFinishedWebhookSchema()` */
  static readonly PostCallFinishedWebhookSchemaPath = '/api/webhooks/notifications/events/CallFinished';

  /**
   * CallFinished webhook payload schema (documentation only).
   *
   * ⚠️ DO NOT CALL THIS ENDPOINT - it's for documentation only! This shows the structure of 'CallFinished' webhook payload that will be sent to your webhook URL.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postCallFinishedWebhookSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  postCallFinishedWebhookSchema$Response(params?: PostCallFinishedWebhookSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CallFinishedWebhookPayload>> {
    const obs = postCallFinishedWebhookSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * CallFinished webhook payload schema (documentation only).
   *
   * ⚠️ DO NOT CALL THIS ENDPOINT - it's for documentation only! This shows the structure of 'CallFinished' webhook payload that will be sent to your webhook URL.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postCallFinishedWebhookSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postCallFinishedWebhookSchema(params?: PostCallFinishedWebhookSchema$Params, context?: HttpContext): Observable<CallFinishedWebhookPayload> {
    const resp = this.postCallFinishedWebhookSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CallFinishedWebhookPayload>): CallFinishedWebhookPayload => r.body)
    );
  }

}
